export default IconClockMinus => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-clock-minus" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M20.477 15.022a9 9 0 1 0 -7.998 5.965" />
  <path d="M12 7v5l3 3" />
  <path d="M16 19h6" />
</svg>`;